<div class="logo">
  <img
    [ngStyle]="{ 'width.px': logoSize }"
    src="assets/images/logo.jpg" alt="Logo">
</div>
